import { subject } from '@casl/ability';
import { Button } from '@mantine/core';
import { IconRouteAltLeft } from '@tabler/icons-react';
import { type FC } from 'react';
import { Link } from 'react-router';
import useApp from '../../providers/App/useApp';
import MantineIcon from '../common/MantineIcon';

type Props = { projectUuid: string };

/**
 * Its own cell rather than an item in the Intelligence menu: automation is not
 * intelligence, and every workflow endpoint needs `manage` on the Project while
 * that menu only needs `view` — a viewer would see a link that 403s.
 */
export const WorkflowsNavButton: FC<Props> = ({ projectUuid }) => {
    const { user } = useApp();
    const canManage =
        user.data?.ability?.can(
            'manage',
            subject('Project', {
                organizationUuid: user.data?.organizationUuid,
                projectUuid,
            }),
        ) ?? false;

    if (!canManage) return null;

    return (
        <Button
            component={Link}
            to={`/projects/${projectUuid}/workflows`}
            variant="default"
            size="xs"
            fz="sm"
            leftSection={
                <MantineIcon color="ldGray.6" icon={IconRouteAltLeft} />
            }
        >
            Workflows
        </Button>
    );
};
